/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { AllRolesList } from '../../pages/ManageInstitutionUsers/roles'

export default function ManageRoles({ selected, handleSelection, error, branch, userType, view }) {
    const getRoleKey = (role) => role.toLowerCase().replace(/\s/g, '-')

    const getSubRoleKey = (role, subrole) =>
        role === "Employees" && subrole === "Directory "
            ? 'employee-directory'
            : role === "Students-Activity" && subrole === "Directory"
                ? 'directory'
                : role === "Employees" && subrole === "Attendance"
                    ? 'employees-attendance'
                    : role === "Students-Activity" && subrole === "Attendance"
                        ? 'students-attendance'
                        : role === "Students-Activity" && subrole === "Academic Reports"
                            ? 'academic-reports'
                            : subrole.toLowerCase().replace(/\s/g, '-')

    const getRoleKeys = (role) => {
        if (AllRolesList[role].length === 0) {
            return [getRoleKey(role)];
        }

        return AllRolesList[role].map(subrole => getSubRoleKey(role, subrole));
    }

    // Extract all selectable role keys from AllRolesList
    const allSubRoles = Object.keys(AllRolesList).flatMap(role => getRoleKeys(role))

    const excludedForStaff = ["financial-years", "institution-users"]

    const filteredSubRoles =
      userType === "staff-user"? allSubRoles.filter((role) => !excludedForStaff.includes(role)): allSubRoles

    const allSelected = filteredSubRoles.every((subRole) =>selected.includes(subRole)
    )
    

    return (
        <div className="mt-[30px]">
            {/* Global Select All Checkbox */}
            <div className="flex items-center ">
                {view === undefined && (
                    <div className="relative checkbox custom-checkBoxBlueBranch1 flex mb-2 ml-1 group">
                        <input
                            type="checkbox"
                            id="select-all-global"
                            checked={allSelected}
                            onChange={() => {
                                if (allSelected) {
                                // Unselect all roles
                                    allSubRoles.forEach(subRole => handleSelection(subRole));
                                } else {
                                // Select all roles
                                    allSubRoles.forEach(subRole => {
                                        if (!selected.includes(subRole)) {
                                            handleSelection(subRole);
                                        }
                                    });
                                }
                            }}
                                
                        />
                        <div className="absolute left-3 bottom-7 bg-gray-300 text-gray-800 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity shadow-md whitespace-nowrap">
                            Select All Roles
                        </div>

                        <label
                            htmlFor={`select-all-global`}
                            className="text-f7 font-normal text-[#031624] pl-2.5 w-full cursor-pointer"
                        >   
                            <h5 className="text-lg font-semibold text-[#000000] cursor-pointer -mt-0.5">
                                Manage Roles
                            </h5>    
                        </label>
                    </div>
                )}
    
                
            </div>

            <div className={`p-3 ${error && selected?.length === 0 ? 'border border-[#F04438]' : 'border border-[#D0D5DDD0]'} rounded error_border`}>
                
               
                <div className="flex -mx-0.5 mb-5 flex-wrap">
                    {Object.keys(AllRolesList).map((role, i) => {
                        if (userType === "staff-user" && (role === "Branch" || role === 'Financial Years')) {
                            return null;
                        }
                        const subRoles = getRoleKeys(role)

                        const roleAllSelected = subRoles.every(subRole => selected.includes(subRole))

                        return (
                            <div className="px-0.5 w-1/5 mb-5" key={i}>
                                <div className="w-full" style={{ display: `${role === 'Institution' && branch ? 'none' : ''}` }}>
                                    <div className="flex items-center">
                                        
                                        {view === undefined && (
                                            <div className="relative checkbox custom-checkBoxBlueBranch1 flex group">
                                                <input
                                                    type="checkbox"
                                                    id={`select-all-${role}`}
                                                    checked={roleAllSelected}
                                                    onChange={() => {
                                                        if (roleAllSelected) {
                                                            subRoles.forEach(subRole => handleSelection(subRole));
                                                        } else {
                                                            subRoles.forEach(subRole => {
                                                                if (!selected.includes(subRole)) {
                                                                    handleSelection(subRole);
                                                                }
                                                            });
                                                        }
                                                    }}
                                                />
                                                <div className="absolute left-6 bottom-7 bg-gray-300 text-gray-800 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity shadow-md whitespace-nowrap">
                                                    Select All Roles
                                                </div>
                                                <label
                                                    htmlFor={`select-all-${role}`}
                                                    className="pl-2.5 w-full cursor-pointer"
                                                >
                                                    <p className="text-f8 font-semibold text-[#031624] -mt-0.5">{role}</p>
                                                </label>
                                            </div>
                                           
                                        )} 
                                       

                                    </div>
                                    

                                    {AllRolesList[role].map((subrole) => {
                                        const subRoleKey = getSubRoleKey(role, subrole)

                                        return (
                                            <div className="relative checkbox custom-checkBoxBlueBranch1 mb-1 ml-1 flex" key={subRoleKey}>
                                                {view === undefined && (
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-${subRoleKey}`}
                                                        checked={selected.includes(subRoleKey)}
                                                        onChange={() => handleSelection(subRoleKey)}
                                                    />
                                                )}
                                                {view === undefined ? (
                                                    <label
                                                        htmlFor={`checkbox-${subRoleKey}`}
                                                        className="text-f7 font-normal text-[#031624] pl-2.5 w-full cursor-pointer"
                                                    >
                                                        {subrole}
                                                    </label>
                                                ) : (
                                                    selected.includes(subRoleKey) && (
                                                        <label
                                                            htmlFor={`checkbox-${subRoleKey}`}
                                                            className="text-f7 font-normal text-[#031624] pl-2.5 w-full cursor-pointer"
                                                        >
                                                            {subrole}
                                                        </label>
                                                    )
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
